export default "__VITE_ASSET__CrLV3flu__"